import { render, staticRenderFns } from "./RequestController.vue?vue&type=template&id=f5825a6c&scoped=true"
import script from "./RequestController.vue?vue&type=script&lang=ts"
export * from "./RequestController.vue?vue&type=script&lang=ts"
import style0 from "./RequestController.vue?vue&type=style&index=0&id=f5825a6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5825a6c",
  null
  
)

export default component.exports